import React, { ReactElement } from 'react';
import { TIconProps } from './Icons.types';

function CircleCheckIcon({
  height = 52,
  width = 52,
  iconColor = '#16be48',
  ...restProps
}: TIconProps): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 63 63"
      data-testid="CircleCheckIcon"
      {...restProps}>
      <g
        transform="translate(1 1)"
        stroke={iconColor}
        fill="none"
        fillRule="evenodd">
        <circle cx={30.5} cy={30.5} r={30.5} fill="#FFF" strokeWidth={2} />
        <path
          fill={iconColor}
          fillRule="nonzero"
          strokeWidth={0.5}
          d="M41.752 22.263a.812.812 0 00-1.196 0L26.839 36.83l-5.395-5.73a.812.812 0 00-1.196 0 .94.94 0 000 1.272l5.993 6.365c.33.35.866.35 1.197 0l14.314-15.203c.33-.35.33-.92 0-1.27z"
        />
      </g>
    </svg>
  );
}

export default CircleCheckIcon;
